// extracted by mini-css-extract-plugin
export default {"registerGlobalBtn":"style_registerGlobalBtn__deNQN","bounce-top":"style_bounce-top__mvJHI"};